(function () {
  const sourceSelector = '.gs-review-count-override';
  const badgeSelector = '.jdgm-widget.jdgm-preview-badge';

  function parseCount(value) {
    const count = Number.parseInt(value, 10);
    return Number.isFinite(count) && count >= 0 ? count : 0;
  }

  function getReviewData(source) {
    return {
      productId: source.dataset.productId,
      counts: {
        1: parseCount(source.dataset.oneStarCount),
        2: parseCount(source.dataset.twoStarCount),
        3: parseCount(source.dataset.threeStarCount),
        4: parseCount(source.dataset.fourStarCount),
        5: parseCount(source.dataset.fiveStarCount),
      },
      total: parseCount(source.dataset.totalCount),
      average: source.dataset.averageRating || '0',
    };
  }

  function replaceNumber(text, value) {
    const replacement = String(value);
    return /\d[\d,]*/.test(text) ? text.replace(/\d[\d,]*/, replacement) : replacement;
  }

  function setText(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function updateCountNodes(scope, total) {
    scope.querySelectorAll('[data-gs-review-total]').forEach((element) => {
      setText(element, replaceNumber(element.textContent, total));
    });
  }

  function updateBadgeContent(badgeContent, data) {
    badgeContent.dataset.numberOfReviews = String(data.total);
    badgeContent.dataset.averageRating = data.average;

    badgeContent.querySelectorAll('.jdgm-prev-badge__stars').forEach((stars) => {
      stars.dataset.score = data.average;
    });

    badgeContent.querySelectorAll('.jdgm-prev-badge__text').forEach((element) => {
      setText(element, replaceNumber(element.textContent, data.total));
    });
  }

  function updateBadge(badge, data) {
    updateBadgeContent(badge.querySelector('.jdgm-prev-badge') || badge, data);
  }

  function localizePreviewBadge(badge) {
    const badgeContent = badge.querySelector('.jdgm-prev-badge') || badge;
    const label = badgeContent.querySelector('.jdgm-prev-badge__text');
    const count = Number.parseInt(badgeContent.dataset.numberOfReviews, 10);

    if (!label || !Number.isFinite(count)) return;

    if (count === 0) {
      setText(label, badge.dataset.gsNoReviewsLabel || 'No reviews');
      return;
    }

    const currentCount = label.textContent.trim().match(/^\d[\d,.]*/)?.[0];
    const formattedCount = currentCount || new Intl.NumberFormat(document.documentElement.lang || undefined).format(count);
    const reviewLabel = count === 1
      ? badge.dataset.gsReviewLabelSingular || 'Review'
      : badge.dataset.gsReviewLabelPlural || 'Reviews';

    setText(label, `${formattedCount} ${reviewLabel}`);
  }

  function updateWidget(widget, data) {
    widget.dataset.numberOfReviews = String(data.total);
    widget.dataset.averageRating = data.average;

    widget.querySelectorAll('.jdgm-rev-widg__summary-text, .jdgm-rev-widg__summary-average').forEach(
      (element) => setText(element, replaceNumber(element.textContent, data.total))
    );

    const rows = Array.from(widget.querySelectorAll('.jdgm-histogram__row'));
    const largestCount = Math.max(...Object.values(data.counts), 0);

    rows.forEach((row) => {
      const rating = Number.parseInt(row.dataset.rating, 10);
      if (!Number.isFinite(rating) || !Object.prototype.hasOwnProperty.call(data.counts, rating)) return;

      const count = data.counts[rating];
      row.dataset.frequency = String(count);
      const frequency = row.querySelector('.jdgm-histogram__frequency');
      if (frequency) setText(frequency, String(count));

      const bar = row.querySelector('.jdgm-histogram__bar-content');
      if (bar) bar.style.width = largestCount ? `${(count / largestCount) * 100}%` : '0%';
    });
  }

  function applySource(source) {
    const data = getReviewData(source);
    const card = source.closest('.gs-product-card, .tabbed-product-card, .complementary-product-card');
    const scope = card || source.closest('section') || document;

    updateCountNodes(scope, data.total);

    if (card) {
      card.querySelectorAll(badgeSelector).forEach((badge) => updateBadge(badge, data));
    }

    if (source.dataset.pageSource === 'true') {
      document.querySelectorAll('.jdgm-rev-widg').forEach((widget) => updateWidget(widget, data));
      document.querySelectorAll('.product-rating-box .jdgm-prev-badge').forEach((badge) => {
        updateBadgeContent(badge, data);
      });
    }

    document.querySelectorAll(`${badgeSelector}[data-id="${data.productId}"]`).forEach((badge) => {
      updateBadge(badge, data);
    });
  }

  function applyAll() {
    document.querySelectorAll(sourceSelector).forEach(applySource);
    document.querySelectorAll(`${badgeSelector}[data-gs-review-label-plural]`).forEach(localizePreviewBadge);
  }

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyAll();
    });
  });

  function start() {
    applyAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
